import React, { useContext, useEffect, useState } from "react";

import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import Title from "../Title";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import useSettings from "../../hooks/useSettings";
import usePlans from "../../hooks/usePlans";
import { ToastContainer, toast } from 'react-toastify';
import { makeStyles } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";
import { Tabs, Tab } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";

//import 'react-toastify/dist/ReactToastify.css';
 
const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 240,
  },
  tab: {
    backgroundColor: theme.palette.options,  //DARK MODE PLW DESIGN//
    borderRadius: 4,
    width: "100%",
    "& .MuiTab-wrapper": {
      color: theme.palette.fontecor,
    },   //DARK MODE PLW DESIGN//
    "& .MuiTabs-flexContainer": {
      justifyContent: "center"
    }


  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    marginBottom: 12,
    width: "100%",
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
}));

export default function Options(props) {
  const { settings, scheduleTypeChanged } = props;
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const isAdmin = String(user?.profile || "").toLowerCase() === "admin";

  const [userRating, setUserRating] = useState("disabled");
  const [crmConvertedQuestion, setCrmConvertedQuestion] = useState("disabled");
  const [loadingCrmConvertedQuestion, setLoadingCrmConvertedQuestion] = useState(false);
  const [scheduleType, setScheduleType] = useState("disabled");
  const [callType, setCallType] = useState("enabled");
  const [chatbotType, setChatbotType] = useState("");
  const [CheckMsgIsGroup, setCheckMsgIsGroupType] = useState("enabled");

  const [loadingUserRating, setLoadingUserRating] = useState(false);
  const [loadingScheduleType, setLoadingScheduleType] = useState(false);
  const [loadingCallType, setLoadingCallType] = useState(false);
  const [loadingChatbotType, setLoadingChatbotType] = useState(false);
  const [loadingCheckMsgIsGroup, setCheckMsgIsGroup] = useState(false);


  //const [ipixcType, setIpIxcType] = useState("");
  //const [loadingIpIxcType, setLoadingIpIxcType] = useState(false);
  //const [tokenixcType, setTokenIxcType] = useState("");
  //const [loadingTokenIxcType, setLoadingTokenIxcType] = useState(false);

  //const [ipmkauthType, setIpMkauthType] = useState("");
  //const [loadingIpMkauthType, setLoadingIpMkauthType] = useState(false);
  //const [clientidmkauthType, setClientIdMkauthType] = useState("");
  //const [loadingClientIdMkauthType, setLoadingClientIdMkauthType] = useState(false);
  //const [clientsecretmkauthType, setClientSecrectMkauthType] = useState("");
  //const [loadingClientSecrectMkauthType, setLoadingClientSecrectMkauthType] = useState(false);

  const [asaasType, setAsaasType] = useState("");
  const [loadingAsaasType, setLoadingAsaasType] = useState(false);
  
  // recursos a mais da plw design

  const [SendGreetingAccepted, setSendGreetingAccepted] = useState("disabled");
  const [loadingSendGreetingAccepted, setLoadingSendGreetingAccepted] = useState(false);
  
  const [SettingsTransfTicket, setSettingsTransfTicket] = useState("disabled");
  const [loadingSettingsTransfTicket, setLoadingSettingsTransfTicket] = useState(false);
  
  const [sendGreetingMessageOneQueues, setSendGreetingMessageOneQueues] = useState("disabled");
  const [loadingSendGreetingMessageOneQueues, setLoadingSendGreetingMessageOneQueues] = useState(false);

  const [autoManageConnection, setAutoManageConnection] = useState("disabled");
  const [loadingAutoManageConnection, setLoadingAutoManageConnection] = useState(false);

  const [unifyTicketsByContact, setUnifyTicketsByContact] = useState("enabled");
  const [loadingUnifyTicketsByContact, setLoadingUnifyTicketsByContact] = useState(false);

  // Chamado de grupo: enabled = um por grupo em qualquer conexão (padrão);
  // disabled = um por conexão, todos exibindo a conversa inteira
  const [groupTicketUnify, setGroupTicketUnify] = useState("enabled");
  const [loadingGroupTicketUnify, setLoadingGroupTicketUnify] = useState(false);

  // Som/aviso de mensagem nova em chamado de grupo (padrão: grupo não avisa)
  const [notifyGroupMessages, setNotifyGroupMessages] = useState("disabled");
  const [loadingNotifyGroupMessages, setLoadingNotifyGroupMessages] = useState(false);
  const [notifyPhoneUnreadMessages, setNotifyPhoneUnreadMessages] = useState("enabled");
  const [loadingNotifyPhoneUnreadMessages, setLoadingNotifyPhoneUnreadMessages] = useState(false);

  const [messageHistory, setMessageHistory] = useState("contact"); // Padrão: histórico por contato
  const [loadingMessageHistory, setLoadingMessageHistory] = useState(false);

  const [ticketConnectionScope, setTicketConnectionScope] = useState("disabled");
  const [loadingTicketConnectionScope, setLoadingTicketConnectionScope] = useState(false);

  const [ticketCloseWithoutInteraction, setTicketCloseWithoutInteraction] = useState("allowed");
  const [loadingTicketCloseWithoutInteraction, setLoadingTicketCloseWithoutInteraction] = useState(false);

  const [askCompletionMessageOnClose, setAskCompletionMessageOnClose] = useState("disabled");
  const [loadingAskCompletionMessageOnClose, setLoadingAskCompletionMessageOnClose] = useState(false);
  const [transferPendingTickets, setTransferPendingTickets] = useState("disabled");
  const [loadingTransferPendingTickets, setLoadingTransferPendingTickets] = useState(false);
  const [transferToOfflineUser, setTransferToOfflineUser] = useState("enabled");
  const [loadingTransferToOfflineUser, setLoadingTransferToOfflineUser] = useState(false);

  const [clientImport, setClientImport] = useState("disabled");
  const [loadingClientImport, setLoadingClientImport] = useState(false);

  const [whatsappConnectionType, setWhatsappConnectionType] = useState("both");
  // Plano inclui WhatsApp via QR Code? Começa em false (falha fechado): o select
  // "Tipo de Conexão WhatsApp" só aparece depois de o plano confirmar.
  const [allowQrConnection, setAllowQrConnection] = useState(false);
  const { getPlanCompany } = usePlans();
  const [loadingWhatsappConnectionType, setLoadingWhatsappConnectionType] = useState(false);

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const planConfigs = await getPlanCompany(undefined, user.companyId);
        setAllowQrConnection(planConfigs?.plan?.useWhatsappQr !== false);
      } catch (err) {
        setAllowQrConnection(false);
      }
    };
    fetchPlan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [attendanceAlarmEnabled, setAttendanceAlarmEnabled] = useState("disabled");
  const [loadingAttendanceAlarmEnabled, setLoadingAttendanceAlarmEnabled] = useState(false);
  const [attendanceAlarmResetEnabled, setAttendanceAlarmResetEnabled] = useState("disabled");
  const [loadingAttendanceAlarmResetEnabled, setLoadingAttendanceAlarmResetEnabled] = useState(false);
  const [attendanceAlarmMinutes, setAttendanceAlarmMinutes] = useState("10");
  const [lastValidAttendanceAlarmMinutes, setLastValidAttendanceAlarmMinutes] = useState("10");
  const [loadingAttendanceAlarmMinutes, setLoadingAttendanceAlarmMinutes] = useState(false);

  const [aiTransferNotifyEnabled, setAiTransferNotifyEnabled] = useState("disabled");
  const [loadingAiTransferNotifyEnabled, setLoadingAiTransferNotifyEnabled] = useState(false);
  const [aiTransferNotifyConnectionId, setAiTransferNotifyConnectionId] = useState("");
  const [loadingAiTransferNotifyConnectionId, setLoadingAiTransferNotifyConnectionId] = useState(false);
  const { whatsApps } = useContext(WhatsAppsContext);
  // type vazio = Baileys (conexões antigas)
  const aiTransferNotifyConnections = (whatsApps || []).filter(
    (w) => (!w.type || w.type === "baileys") && w.status !== "deleted"
  );
  const aiTransferNotifyConnectionValue = aiTransferNotifyConnections.some(
    (w) => String(w.id) === aiTransferNotifyConnectionId
  )
    ? aiTransferNotifyConnectionId
    : "";

  const [aiTransferNotifyNumbers, setAiTransferNotifyNumbers] = useState("");
  const [lastSavedAiTransferNotifyNumbers, setLastSavedAiTransferNotifyNumbers] = useState("");
  const [loadingAiTransferNotifyNumbers, setLoadingAiTransferNotifyNumbers] = useState(false);

  const [outOfHoursMessageInterval, setOutOfHoursMessageInterval] = useState("60");
  const [lastValidOutOfHoursMessageInterval, setLastValidOutOfHoursMessageInterval] = useState("60");
  const [loadingOutOfHoursMessageInterval, setLoadingOutOfHoursMessageInterval] = useState(false);

  const [sidebarBehavior, setSidebarBehavior] = useState("collapsed");
  const [loadingSidebarBehavior, setLoadingSidebarBehavior] = useState(false);

  const [sidebarSubmenuBehavior, setSidebarSubmenuBehavior] = useState("collapsible");
  const [loadingSidebarSubmenuBehavior, setLoadingSidebarSubmenuBehavior] = useState(false);

  // Chave OpenAI para transcrição automática de áudios (admin-only; o backend
  // filtra essa key do GET /settings para não-admins)
  const [transcriptionApiKey, setTranscriptionApiKey] = useState("");
  const [loadingTranscriptionApiKey, setLoadingTranscriptionApiKey] = useState(false);
  const [showTranscriptionApiKey, setShowTranscriptionApiKey] = useState(false);

  const { update } = useSettings();

  const updatedMessage = i18n.t("settings.options.messages.updated");
  const updateErrorMessage = i18n.t("settings.options.messages.updateError");

  useEffect(() => {
    if (Array.isArray(settings) && settings.length) {
      console.log('🔧 [Options] Total de settings recebidos:', settings.length);
      console.log('🔧 [Options] Settings:', settings);
      
      const userRating = settings.find((s) => s.key === "userRating");
      if (userRating) {
        setUserRating(userRating.value);
      }
      const crmConvertedQuestion = settings.find((s) => s.key === "crmConvertedQuestion");
      if (crmConvertedQuestion) {
        setCrmConvertedQuestion(crmConvertedQuestion.value);
      }
      const scheduleType = settings.find((s) => s.key === "scheduleType");
      if (scheduleType) {
        setScheduleType(scheduleType.value);
      }
      const callType = settings.find((s) => s.key === "call");
      if (callType) {
        setCallType(callType.value);
      }
      const CheckMsgIsGroup = settings.find((s) => s.key === "CheckMsgIsGroup");
      if (CheckMsgIsGroup) {
        setCheckMsgIsGroupType(CheckMsgIsGroup.value);
      }
	  
	  {/*PLW DESIGN SAUDAÇÃO*/}
      const SendGreetingAccepted = settings.find((s) => s.key === "sendGreetingAccepted");
      if (SendGreetingAccepted) {
        setSendGreetingAccepted(SendGreetingAccepted.value);
      }	 
	  {/*PLW DESIGN SAUDAÇÃO*/}	 
	  
	  {/*TRANSFERIR TICKET*/}	
	  const SettingsTransfTicket = settings.find((s) => s.key === "sendMsgTransfTicket");
      if (SettingsTransfTicket) {
        setSettingsTransfTicket(SettingsTransfTicket.value);
      }
	  {/*TRANSFERIR TICKET*/}

      const sendGreetingMessageOneQueues = settings.find((s) => s.key === "sendGreetingMessageOneQueues");
      if (sendGreetingMessageOneQueues) {
        setSendGreetingMessageOneQueues(sendGreetingMessageOneQueues.value)
      }	  

      const autoManageConnection = settings.find((s) => s.key === "autoManageConnection");
      console.log('🔧 [Options] autoManageConnection encontrado:', autoManageConnection);
      if (autoManageConnection) {
        console.log('🔧 [Options] Setando autoManageConnection com valor:', autoManageConnection.value);
        setAutoManageConnection(autoManageConnection.value);
      } else {
        console.warn('⚠️ [Options] autoManageConnection NÃO encontrado nos settings!');
      }

      const unifyTicketsByContact = settings.find((s) => s.key === "unifyTicketsByContact");
      if (unifyTicketsByContact) {
        setUnifyTicketsByContact(unifyTicketsByContact.value);
      }

      const groupTicketUnifySetting = settings.find((s) => s.key === "groupTicketUnify");
      if (groupTicketUnifySetting) {
        setGroupTicketUnify(groupTicketUnifySetting.value === "disabled" ? "disabled" : "enabled");
      }

      const notifyGroupMessagesSetting = settings.find((s) => s.key === "notifyGroupMessages");
      if (notifyGroupMessagesSetting) {
        setNotifyGroupMessages(notifyGroupMessagesSetting.value === "enabled" ? "enabled" : "disabled");
      }

      const notifyPhoneUnreadMessagesSetting = settings.find((s) => s.key === "notifyPhoneUnreadMessages");
      if (notifyPhoneUnreadMessagesSetting) {
        setNotifyPhoneUnreadMessages(notifyPhoneUnreadMessagesSetting.value === "disabled" ? "disabled" : "enabled");
      }

      const messageHistory = settings.find((s) => s.key === "messageHistory");
      if (messageHistory) {
        setMessageHistory(messageHistory.value);
      }

      const ticketConnectionScope = settings.find((s) => s.key === "ticketConnectionScope");
      if (ticketConnectionScope) {
        setTicketConnectionScope(ticketConnectionScope.value);
      }

      const ticketCloseWithoutInteraction = settings.find((s) => s.key === "ticketCloseWithoutInteraction");
      if (ticketCloseWithoutInteraction) {
        setTicketCloseWithoutInteraction(ticketCloseWithoutInteraction.value);
      }

      const askCompletionMessageOnClose = settings.find((s) => s.key === "askCompletionMessageOnClose");
      if (askCompletionMessageOnClose) {
        setAskCompletionMessageOnClose(askCompletionMessageOnClose.value);
      }

      const transferPendingTickets = settings.find((s) => s.key === "transferPendingTickets");
      if (transferPendingTickets) {
        setTransferPendingTickets(transferPendingTickets.value);
      }

      const transferToOfflineUser = settings.find((s) => s.key === "transferToOfflineUser");
      if (transferToOfflineUser) {
        setTransferToOfflineUser(transferToOfflineUser.value);
      }

      const clientImport = settings.find((s) => s.key === "clientImport");
      console.log('🔧 [Options] clientImport encontrado:', clientImport);
      if (clientImport) {
        console.log('🔧 [Options] Setando clientImport com valor:', clientImport.value);
        setClientImport(clientImport.value);
      } else {
        console.warn('⚠️ [Options] clientImport NÃO encontrado nos settings!');
      }

      const whatsappConnectionType = settings.find((s) => s.key === "whatsappConnectionType");
      if (whatsappConnectionType) {
        setWhatsappConnectionType(whatsappConnectionType.value);
      }

      const sidebarBehavior = settings.find((s) => s.key === "sidebarBehavior");
      if (sidebarBehavior) {
        setSidebarBehavior(sidebarBehavior.value);
      }

      const sidebarSubmenuBehavior = settings.find((s) => s.key === "sidebarSubmenuBehavior");
      if (sidebarSubmenuBehavior) {
        setSidebarSubmenuBehavior(sidebarSubmenuBehavior.value);
      }

      const attendanceAlarmMinutes = settings.find((s) => s.key === "attendanceAlarmMinutes");
      if (attendanceAlarmMinutes) {
        const normalizedMinutes = String(attendanceAlarmMinutes.value);
        setAttendanceAlarmMinutes(normalizedMinutes);
        setLastValidAttendanceAlarmMinutes(normalizedMinutes);
      }

      const aiTransferNotifyEnabled = settings.find((s) => s.key === "aiTransferNotifyEnabled");
      if (aiTransferNotifyEnabled) {
        setAiTransferNotifyEnabled(aiTransferNotifyEnabled.value === "enabled" ? "enabled" : "disabled");
      }

      const aiTransferNotifyConnectionId = settings.find((s) => s.key === "aiTransferNotifyConnectionId");
      if (aiTransferNotifyConnectionId) {
        setAiTransferNotifyConnectionId(String(aiTransferNotifyConnectionId.value || ""));
      }

      const aiTransferNotifyNumbers = settings.find((s) => s.key === "aiTransferNotifyNumbers");
      if (aiTransferNotifyNumbers) {
        setAiTransferNotifyNumbers(aiTransferNotifyNumbers.value || "");
        setLastSavedAiTransferNotifyNumbers(aiTransferNotifyNumbers.value || "");
      }

      const outOfHoursMessageInterval = settings.find((s) => s.key === "outOfHoursMessageInterval");
      if (outOfHoursMessageInterval) {
        const normalizedInterval = String(outOfHoursMessageInterval.value);
        setOutOfHoursMessageInterval(normalizedInterval);
        setLastValidOutOfHoursMessageInterval(normalizedInterval);
      }

      const attendanceAlarmEnabled = settings.find((s) => s.key === "attendanceAlarmEnabled");
      if (attendanceAlarmEnabled) {
        setAttendanceAlarmEnabled(attendanceAlarmEnabled.value);
      }

      const attendanceAlarmResetEnabled = settings.find((s) => s.key === "attendanceAlarmResetEnabled");
      if (attendanceAlarmResetEnabled) {
        setAttendanceAlarmResetEnabled(attendanceAlarmResetEnabled.value);
      }

      const transcriptionApiKeySetting = settings.find((s) => s.key === "transcriptionApiKey");
      if (transcriptionApiKeySetting) {
        setTranscriptionApiKey(transcriptionApiKeySetting.value);
      }
	  
      const chatbotType = settings.find((s) => s.key === "chatBotType");
      if (chatbotType) {
        setChatbotType(chatbotType.value);
      }

	    {/*const ipixcType = settings.find((s) => s.key === "ipixc");
      if (ipixcType) {
        setIpIxcType(ipixcType.value);
      }*/}

      {/*const tokenixcType = settings.find((s) => s.key === "tokenixc");
      if (tokenixcType) {
        setTokenIxcType(tokenixcType.value);
      }*/}

      {/*const ipmkauthType = settings.find((s) => s.key === "ipmkauth");
      if (ipmkauthType) {
        setIpMkauthType(ipmkauthType.value);
      }*/}

     {/* const clientidmkauthType = settings.find((s) => s.key === "clientidmkauth");
      if (clientidmkauthType) {
        setClientIdMkauthType(clientidmkauthType.value);
      }*/}

      {/*const clientsecretmkauthType = settings.find((s) => s.key === "clientsecretmkauth");
      if (clientsecretmkauthType) {
        setClientSecrectMkauthType(clientsecretmkauthType.value);
      }*/}

      const asaasType = settings.find((s) => s.key === "asaas");
      if (asaasType) {
        setAsaasType(asaasType.value);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  async function handleChangeUserRating(value) {
    setUserRating(value);
    setLoadingUserRating(true);
    await update({
      key: "userRating",
      value,
    });
    toast.success(updatedMessage);
    setLoadingUserRating(false);
  }

  async function handleChangeCrmConvertedQuestion(value) {
    setCrmConvertedQuestion(value);
    setLoadingCrmConvertedQuestion(true);
    await update({
      key: "crmConvertedQuestion",
      value,
    });
    toast.success(updatedMessage);
    setLoadingCrmConvertedQuestion(false);
  }
  
    async function handleSendGreetingMessageOneQueues(value) {
    setSendGreetingMessageOneQueues(value);
    setLoadingSendGreetingMessageOneQueues(true);
    await update({
      key: "sendGreetingMessageOneQueues",
      value,
    });
	toast.success(updatedMessage);
    setLoadingSendGreetingMessageOneQueues(false);
  }

  async function handleScheduleType(value) {
    setScheduleType(value);
    setLoadingScheduleType(true);
    await update({
      key: "scheduleType",
      value,
    });
    //toast.success("Oraçãpeo atualizada com sucesso.");
    toast.success(updatedMessage, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
      });
    setLoadingScheduleType(false);
    if (typeof scheduleTypeChanged === "function") {
      scheduleTypeChanged(value);
    }
  }

  async function handleCallType(value) {
    setCallType(value);
    setLoadingCallType(true);
    await update({
      key: "call",
      value,
    });
    toast.success(updatedMessage);
    setLoadingCallType(false);
  }

  async function handleSidebarBehavior(value) {
    setSidebarBehavior(value);
    setLoadingSidebarBehavior(true);
    await update({
      key: "sidebarBehavior",
      value,
    });
    toast.success(updatedMessage);
    setLoadingSidebarBehavior(false);
  }

  async function handleSidebarSubmenuBehavior(value) {
    setSidebarSubmenuBehavior(value);
    setLoadingSidebarSubmenuBehavior(true);
    await update({
      key: "sidebarSubmenuBehavior",
      value,
    });
    toast.success(updatedMessage);
    setLoadingSidebarSubmenuBehavior(false);
  }

  async function handleChatbotType(value) {
    setChatbotType(value);
    setLoadingChatbotType(true);
    await update({
      key: "chatBotType",
      value,
    });
    toast.success(updatedMessage);
    setLoadingChatbotType(false);
  }

  async function handleGroupType(value) {
    setCheckMsgIsGroupType(value);
    setCheckMsgIsGroup(true);
    await update({
      key: "CheckMsgIsGroup",
      value,
    });
    toast.success(updatedMessage);
    setCheckMsgIsGroup(false);
    /*     if (typeof scheduleTypeChanged === "function") {
          scheduleTypeChanged(value);
        } */
  }
  
  {/*NOVO CÓDIGO*/}  
  async function handleSendGreetingAccepted(value) {
    setSendGreetingAccepted(value);
    setLoadingSendGreetingAccepted(true);
    await update({
      key: "sendGreetingAccepted",
      value,
    });
	toast.success(updatedMessage);
    setLoadingSendGreetingAccepted(false);
  }  
  
  
  {/*NOVO CÓDIGO*/}    

  async function handleSettingsTransfTicket(value) {
    setSettingsTransfTicket(value);
    setLoadingSettingsTransfTicket(true);
    await update({
      key: "sendMsgTransfTicket",
      value,
    });

    toast.success(updatedMessage);
    setLoadingSettingsTransfTicket(false);
  }

  async function handleAutoManageConnection(value) {
    console.log('🔧 [Options] handleAutoManageConnection chamado com valor:', value);
    setAutoManageConnection(value);
    setLoadingAutoManageConnection(true);
    try {
      await update({
        key: "autoManageConnection",
        value,
      });
      console.log('✅ [Options] autoManageConnection atualizado com sucesso para:', value);
      toast.success(updatedMessage);
    } catch (error) {
      console.error('❌ [Options] Erro ao atualizar autoManageConnection:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingAutoManageConnection(false);
  }

  async function handleTicketConnectionScope(value) {
    setTicketConnectionScope(value);
    setLoadingTicketConnectionScope(true);
    try {
      await update({
        key: "ticketConnectionScope",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar ticketConnectionScope:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingTicketConnectionScope(false);
  }

  async function handleTicketCloseWithoutInteraction(value) {
    setTicketCloseWithoutInteraction(value);
    setLoadingTicketCloseWithoutInteraction(true);
    try {
      await update({
        key: "ticketCloseWithoutInteraction",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar ticketCloseWithoutInteraction:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingTicketCloseWithoutInteraction(false);
  }

  async function handleAskCompletionMessageOnClose(value) {
    setAskCompletionMessageOnClose(value);
    setLoadingAskCompletionMessageOnClose(true);
    try {
      await update({
        key: "askCompletionMessageOnClose",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar askCompletionMessageOnClose:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingAskCompletionMessageOnClose(false);
  }

  async function handleTransferPendingTickets(value) {
    setTransferPendingTickets(value);
    setLoadingTransferPendingTickets(true);
    try {
      await update({
        key: "transferPendingTickets",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar transferPendingTickets:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingTransferPendingTickets(false);
  }

  async function handleTransferToOfflineUser(value) {
    setTransferToOfflineUser(value);
    setLoadingTransferToOfflineUser(true);
    try {
      await update({
        key: "transferToOfflineUser",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar transferToOfflineUser:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingTransferToOfflineUser(false);
  }

  async function handleGroupTicketUnify(value) {
    setGroupTicketUnify(value);
    setLoadingGroupTicketUnify(true);
    try {
      await update({
        key: "groupTicketUnify",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar groupTicketUnify:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingGroupTicketUnify(false);
  }

  async function handleNotifyGroupMessages(value) {
    setNotifyGroupMessages(value);
    setLoadingNotifyGroupMessages(true);
    try {
      await update({
        key: "notifyGroupMessages",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar notifyGroupMessages:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingNotifyGroupMessages(false);
  }

  async function handleNotifyPhoneUnreadMessages(value) {
    setNotifyPhoneUnreadMessages(value);
    setLoadingNotifyPhoneUnreadMessages(true);
    try {
      await update({
        key: "notifyPhoneUnreadMessages",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar notifyPhoneUnreadMessages:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingNotifyPhoneUnreadMessages(false);
  }

  async function handleUnifyTicketsByContact(value) {
    setUnifyTicketsByContact(value);
    setLoadingUnifyTicketsByContact(true);
    try {
      await update({
        key: "unifyTicketsByContact",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar unifyTicketsByContact:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingUnifyTicketsByContact(false);
  }

  async function handleMessageHistory(value) {
    setMessageHistory(value);
    setLoadingMessageHistory(true);
    try {
      await update({
        key: "messageHistory",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar messageHistory:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingMessageHistory(false);
  }

  async function handleClientImport(value) {
    setClientImport(value);
    setLoadingClientImport(true);
    try {
      await update({
        key: "clientImport",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar clientImport:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingClientImport(false);
  }

 
 {/*async function handleChangeIPIxc(value) {
    setIpIxcType(value);
    setLoadingIpIxcType(true);
    await update({
      key: "ipixc",
      value,
    });
    toast.success("Operação atualizada com sucesso.");
    setLoadingIpIxcType(false);
  }

   {/*async function handleChangeTokenIxc(value) {
    setTokenIxcType(value);
    setLoadingTokenIxcType(true);
    await update({
      key: "tokenixc",
      value,
    });
    toast.success("Operação atualizada com sucesso.");
    setLoadingTokenIxcType(false);
  }

  async function handleChangeIpMkauth(value) {
    setIpMkauthType(value);
    setLoadingIpMkauthType(true);
    await update({
      key: "ipmkauth",
      value,
    });
    toast.success("Operação atualizada com sucesso.");
    setLoadingIpMkauthType(false);
  }

  async function handleChangeClientIdMkauth(value) {
    setClientIdMkauthType(value);
    setLoadingClientIdMkauthType(true);
    await update({
      key: "clientidmkauth",
      value,
    });
    toast.success("Operação atualizada com sucesso.");
    setLoadingClientIdMkauthType(false);
  }

  async function handleChangeClientSecrectMkauth(value) {
    setClientSecrectMkauthType(value);
    setLoadingClientSecrectMkauthType(true);
    await update({
      key: "clientsecretmkauth",
      value,
    });
    toast.success("Operação atualizada com sucesso.");
    setLoadingClientSecrectMkauthType(false);
  }*/}

  async function handleChangeAsaas(value) {
    setAsaasType(value);
    setLoadingAsaasType(true);
    await update({
      key: "asaas",
      value,
    });
    toast.success(updatedMessage);
    setLoadingAsaasType(false);
  }


  async function handleWhatsappConnectionType(value) {
    setWhatsappConnectionType(value);
    setLoadingWhatsappConnectionType(true);
    try {
      await update({
        key: "whatsappConnectionType",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error('Erro ao atualizar whatsappConnectionType:', error);
      toast.error(updateErrorMessage);
    }
    setLoadingWhatsappConnectionType(false);
  }

  async function handleAiTransferNotifyEnabled(value) {
    setAiTransferNotifyEnabled(value);
    setLoadingAiTransferNotifyEnabled(true);
    try {
      await update({
        key: "aiTransferNotifyEnabled",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error("Erro ao atualizar aiTransferNotifyEnabled:", error);
      toast.error(updateErrorMessage);
    } finally {
      setLoadingAiTransferNotifyEnabled(false);
    }
  }

  async function handleAiTransferNotifyConnectionId(value) {
    const previousValue = aiTransferNotifyConnectionId;
    setAiTransferNotifyConnectionId(value);
    setLoadingAiTransferNotifyConnectionId(true);
    try {
      await update({
        key: "aiTransferNotifyConnectionId",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error("Erro ao atualizar aiTransferNotifyConnectionId:", error);
      setAiTransferNotifyConnectionId(previousValue);
      toast.error(updateErrorMessage);
    } finally {
      setLoadingAiTransferNotifyConnectionId(false);
    }
  }

  // Cada número só com dígitos (DDI + DDD + número), separados por ";".
  async function handleAiTransferNotifyNumbers(value) {
    const numbers = String(value || "")
      .split(/[;,\n]/)
      .map((n) => n.replace(/\D/g, ""))
      .filter(Boolean);

    if (numbers.some((n) => n.length < 10 || n.length > 15)) {
      toast.error(i18n.t("settings.options.fields.aiTransferNotifyNumbers.errors.invalid"));
      setAiTransferNotifyNumbers(lastSavedAiTransferNotifyNumbers);
      return;
    }

    const normalizedValue = numbers.join(";");
    setAiTransferNotifyNumbers(normalizedValue);
    if (normalizedValue === lastSavedAiTransferNotifyNumbers) return;

    setLoadingAiTransferNotifyNumbers(true);
    try {
      await update({
        key: "aiTransferNotifyNumbers",
        value: normalizedValue,
      });
      setLastSavedAiTransferNotifyNumbers(normalizedValue);
      toast.success(updatedMessage);
    } catch (error) {
      console.error("Erro ao atualizar aiTransferNotifyNumbers:", error);
      setAiTransferNotifyNumbers(lastSavedAiTransferNotifyNumbers);
      toast.error(updateErrorMessage);
    } finally {
      setLoadingAiTransferNotifyNumbers(false);
    }
  }

  async function handleAttendanceAlarmMinutes(value) {
    const parsedValue = Number(value);

    if (!Number.isFinite(parsedValue) || parsedValue < 1) {
      toast.error(i18n.t("settings.options.fields.attendanceAlarmMinutes.errors.invalid"));
      setAttendanceAlarmMinutes(lastValidAttendanceAlarmMinutes);
      return;
    }

    const normalizedValue = String(Math.floor(parsedValue));
    setAttendanceAlarmMinutes(normalizedValue);
    setLoadingAttendanceAlarmMinutes(true);

    try {
      await update({
        key: "attendanceAlarmMinutes",
        value: normalizedValue,
      });
      setLastValidAttendanceAlarmMinutes(normalizedValue);
      toast.success(updatedMessage);
    } catch (error) {
      console.error("Erro ao atualizar attendanceAlarmMinutes:", error);
      setAttendanceAlarmMinutes(lastValidAttendanceAlarmMinutes);
      toast.error(updateErrorMessage);
    }

    setLoadingAttendanceAlarmMinutes(false);
  }

  async function handleOutOfHoursMessageInterval(value) {
    const parsedValue = String(value).trim() === "" ? NaN : Number(value);

    if (!Number.isFinite(parsedValue) || parsedValue < 0 || parsedValue > 1440) {
      toast.error(i18n.t("settings.options.fields.outOfHoursMessageInterval.errors.invalid"));
      setOutOfHoursMessageInterval(lastValidOutOfHoursMessageInterval);
      return;
    }

    const normalizedValue = String(Math.floor(parsedValue));
    setOutOfHoursMessageInterval(normalizedValue);
    if (normalizedValue === lastValidOutOfHoursMessageInterval) {
      return;
    }

    setLoadingOutOfHoursMessageInterval(true);

    try {
      await update({
        key: "outOfHoursMessageInterval",
        value: normalizedValue,
      });
      setLastValidOutOfHoursMessageInterval(normalizedValue);
      toast.success(updatedMessage);
    } catch (error) {
      console.error("Erro ao atualizar outOfHoursMessageInterval:", error);
      setOutOfHoursMessageInterval(lastValidOutOfHoursMessageInterval);
      toast.error(updateErrorMessage);
    }

    setLoadingOutOfHoursMessageInterval(false);
  }

  async function handleTranscriptionApiKey(value) {
    const normalizedValue = String(value ?? "").trim();
    setTranscriptionApiKey(normalizedValue);
    setLoadingTranscriptionApiKey(true);

    try {
      await update({
        key: "transcriptionApiKey",
        value: normalizedValue,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error("Erro ao atualizar transcriptionApiKey:", error);
      toast.error(updateErrorMessage);
    }

    setLoadingTranscriptionApiKey(false);
  }

  async function handleAttendanceAlarmEnabled(value) {
    setAttendanceAlarmEnabled(value);
    setLoadingAttendanceAlarmEnabled(true);

    try {
      await update({
        key: "attendanceAlarmEnabled",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error("Erro ao atualizar attendanceAlarmEnabled:", error);
      toast.error(updateErrorMessage);
    }

    setLoadingAttendanceAlarmEnabled(false);
  }

  async function handleAttendanceAlarmResetEnabled(value) {
    setAttendanceAlarmResetEnabled(value);
    setLoadingAttendanceAlarmResetEnabled(true);

    try {
      await update({
        key: "attendanceAlarmResetEnabled",
        value,
      });
      toast.success(updatedMessage);
    } catch (error) {
      console.error("Erro ao atualizar attendanceAlarmResetEnabled:", error);
      toast.error(updateErrorMessage);
    }

    setLoadingAttendanceAlarmResetEnabled(false);
  }

  return (
    <>
      <Grid spacing={3} container>
        {/* <Grid xs={12} item>
                    <Title>Configurações Gerais</Title>
                </Grid> */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="ratings-label">{i18n.t("settings.options.fields.userRating.label")}</InputLabel>
            <Select
              labelId="ratings-label"
              value={userRating}
              onChange={async (e) => {
                handleChangeUserRating(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.userRating.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.userRating.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingUserRating && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="crm-converted-label">{i18n.t("settings.options.fields.crmConvertedQuestion.label")}</InputLabel>
            <Select
              labelId="crm-converted-label"
              value={crmConvertedQuestion}
              onChange={async (e) => {
                handleChangeCrmConvertedQuestion(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.crmConvertedQuestion.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.crmConvertedQuestion.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingCrmConvertedQuestion
                ? i18n.t("settings.options.loading")
                : i18n.t("settings.options.fields.crmConvertedQuestion.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="schedule-type-label">
              {i18n.t("settings.options.fields.scheduleType.label")}
            </InputLabel>
            <Select
              labelId="schedule-type-label"
              value={scheduleType}
              onChange={async (e) => {
                handleScheduleType(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.scheduleType.options.disabled")}</MenuItem>
              <MenuItem value={"queue"}>{i18n.t("settings.options.fields.scheduleType.options.queue")}</MenuItem>
              <MenuItem value={"company"}>{i18n.t("settings.options.fields.scheduleType.options.company")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingScheduleType && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>
        {scheduleType !== "disabled" && (
          <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="outOfHoursMessageInterval"
              name="outOfHoursMessageInterval"
              margin="dense"
              label={i18n.t("settings.options.fields.outOfHoursMessageInterval.label")}
              variant="outlined"
              type="number"
              inputProps={{ min: 0, max: 1440, step: 1 }}
              value={outOfHoursMessageInterval}
              onChange={(e) => setOutOfHoursMessageInterval(e.target.value)}
              onBlur={(e) => handleOutOfHoursMessageInterval(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleOutOfHoursMessageInterval(outOfHoursMessageInterval);
                }
              }}
            />
            <FormHelperText>
              {loadingOutOfHoursMessageInterval
                ? i18n.t("settings.options.loading")
                : i18n.t("settings.options.fields.outOfHoursMessageInterval.helper")}
            </FormHelperText>
          </FormControl>
          </Grid>
        )}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="group-type-label">
              {i18n.t("settings.options.fields.checkMsgIsGroup.label")}
            </InputLabel>
            <Select
              labelId="group-type-label"
              value={CheckMsgIsGroup}
              onChange={async (e) => {
                handleGroupType(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.checkMsgIsGroup.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.checkMsgIsGroup.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingScheduleType && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="call-type-label">
              {i18n.t("settings.options.fields.callType.label")}
            </InputLabel>
            <Select
              labelId="call-type-label"
              value={callType}
              onChange={async (e) => {
                handleCallType(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.callType.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.callType.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingCallType && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="chatbot-type-label">
              {i18n.t("settings.options.fields.chatbotType.label")}
            </InputLabel>
            <Select
              labelId="chatbot-type-label"
              value={chatbotType}
              onChange={async (e) => {
                handleChatbotType(e.target.value);
              }}
            >
              <MenuItem value={"text"}>{i18n.t("settings.options.fields.chatbotType.options.text")}</MenuItem>
			 {/*<MenuItem value={"button"}>Botão</MenuItem>*/}
             {/*<MenuItem value={"list"}>Lista</MenuItem>*/}
            </Select>
            <FormHelperText>
              {loadingChatbotType && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>
		{/* ENVIAR SAUDAÇÃO AO ACEITAR O TICKET */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="sendGreetingAccepted-label">{i18n.t("settings.options.fields.sendGreetingAccepted.label")}</InputLabel>
            <Select
              labelId="sendGreetingAccepted-label"
              value={SendGreetingAccepted}
              onChange={async (e) => {
                handleSendGreetingAccepted(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.sendGreetingAccepted.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.sendGreetingAccepted.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendGreetingAccepted && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>
		{/* ENVIAR SAUDAÇÃO AO ACEITAR O TICKET */}
		
		{/* ENVIAR MENSAGEM DE TRANSFERENCIA DE SETOR/ATENDENTE */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="sendMsgTransfTicket-label">{i18n.t("settings.options.fields.sendMsgTransfTicket.label")}</InputLabel>
            <Select
              labelId="sendMsgTransfTicket-label"
              value={SettingsTransfTicket}
              onChange={async (e) => {
                handleSettingsTransfTicket(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.sendMsgTransfTicket.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.sendMsgTransfTicket.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingSettingsTransfTicket && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>

		{/* BOTÃO TRANSFERIR NOS CHAMADOS EM AGUARDANDO */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="transferPendingTickets-label">{i18n.t("settings.options.fields.transferPendingTickets.label")}</InputLabel>
            <Select
              labelId="transferPendingTickets-label"
              value={transferPendingTickets}
              onChange={async (e) => {
                handleTransferPendingTickets(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.transferPendingTickets.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.transferPendingTickets.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingTransferPendingTickets ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.transferPendingTickets.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>

		{/* TRANSFERIR CHAMADO PARA USUÁRIO OFFLINE */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="transferToOfflineUser-label">{i18n.t("settings.options.fields.transferToOfflineUser.label")}</InputLabel>
            <Select
              labelId="transferToOfflineUser-label"
              value={transferToOfflineUser}
              onChange={async (e) => {
                handleTransferToOfflineUser(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.transferToOfflineUser.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.transferToOfflineUser.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingTransferToOfflineUser ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.transferToOfflineUser.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>
		
		{/* ENVIAR SAUDAÇÃO QUANDO HOUVER SOMENTE 1 FILA */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="sendGreetingMessageOneQueues-label">{i18n.t("settings.options.fields.sendGreetingMessageOneQueues.label")}</InputLabel>
            <Select
              labelId="sendGreetingMessageOneQueues-label"
              value={sendGreetingMessageOneQueues}
              onChange={async (e) => {
                handleSendGreetingMessageOneQueues(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.sendGreetingMessageOneQueues.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.sendGreetingMessageOneQueues.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendGreetingMessageOneQueues && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>

		{/* AUTO GERENCIAMENTO DE CONEXÃO */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="autoManageConnection-label">{i18n.t("settings.options.fields.autoManageConnection.label")}</InputLabel>
            <Select
              labelId="autoManageConnection-label"
              value={autoManageConnection}
              onChange={async (e) => {
                handleAutoManageConnection(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.autoManageConnection.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.autoManageConnection.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingAutoManageConnection && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>

		{/* COMPORTAMENTO DO MENU LATERAL */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="sidebarBehavior-label">{i18n.t("settings.options.fields.sidebarBehavior.label")}</InputLabel>
            <Select
              labelId="sidebarBehavior-label"
              value={sidebarBehavior}
              onChange={async (e) => {
                handleSidebarBehavior(e.target.value);
              }}
            >
              <MenuItem value={"expanded"}>{i18n.t("settings.options.fields.sidebarBehavior.options.expanded")}</MenuItem>
              <MenuItem value={"collapsed"}>{i18n.t("settings.options.fields.sidebarBehavior.options.collapsed")}</MenuItem>
              <MenuItem value={"collapsed_no_hover"}>{i18n.t("settings.options.fields.sidebarBehavior.options.collapsed_no_hover")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingSidebarBehavior && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>

		{/* COMPORTAMENTO DOS SUBMENUS */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="sidebarSubmenuBehavior-label">{i18n.t("settings.options.fields.sidebarSubmenuBehavior.label")}</InputLabel>
            <Select
              labelId="sidebarSubmenuBehavior-label"
              value={sidebarSubmenuBehavior}
              onChange={async (e) => {
                handleSidebarSubmenuBehavior(e.target.value);
              }}
            >
              <MenuItem value={"expanded"}>{i18n.t("settings.options.fields.sidebarSubmenuBehavior.options.expanded")}</MenuItem>
              <MenuItem value={"collapsible"}>{i18n.t("settings.options.fields.sidebarSubmenuBehavior.options.collapsible")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingSidebarSubmenuBehavior && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>

		{/* UNIFICAR CONVERSAS POR CONTATO */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="unifyTicketsByContact-label">{i18n.t("settings.options.fields.unifyTicketsByContact.label")}</InputLabel>
            <Select
              labelId="unifyTicketsByContact-label"
              value={unifyTicketsByContact}
              onChange={async (e) => {
                handleUnifyTicketsByContact(e.target.value);
              }}
            >
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.unifyTicketsByContact.options.enabled")}</MenuItem>
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.unifyTicketsByContact.options.disabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingUnifyTicketsByContact ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.unifyTicketsByContact.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>

		{/* CHAMADO DE GRUPO: UM POR GRUPO OU UM POR CONEXÃO */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="groupTicketUnify-label">{i18n.t("settings.options.fields.groupTicketUnify.label")}</InputLabel>
            <Select
              labelId="groupTicketUnify-label"
              value={groupTicketUnify}
              onChange={async (e) => {
                handleGroupTicketUnify(e.target.value);
              }}
            >
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.groupTicketUnify.options.enabled")}</MenuItem>
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.groupTicketUnify.options.disabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingGroupTicketUnify ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.groupTicketUnify.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>

		{/* NOTIFICAR MENSAGENS DE GRUPO */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="notifyGroupMessages-label">{i18n.t("settings.options.fields.notifyGroupMessages.label")}</InputLabel>
            <Select
              labelId="notifyGroupMessages-label"
              value={notifyGroupMessages}
              onChange={async (e) => {
                handleNotifyGroupMessages(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.notifyGroupMessages.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.notifyGroupMessages.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingNotifyGroupMessages ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.notifyGroupMessages.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>

		{/* AVISAR O CELULAR DE MENSAGEM SEM LEITURA */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="notifyPhoneUnreadMessages-label">{i18n.t("settings.options.fields.notifyPhoneUnreadMessages.label")}</InputLabel>
            <Select
              labelId="notifyPhoneUnreadMessages-label"
              value={notifyPhoneUnreadMessages}
              onChange={async (e) => {
                handleNotifyPhoneUnreadMessages(e.target.value);
              }}
            >
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.notifyPhoneUnreadMessages.options.enabled")}</MenuItem>
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.notifyPhoneUnreadMessages.options.disabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingNotifyPhoneUnreadMessages ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.notifyPhoneUnreadMessages.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>

		{/* HISTÓRICO DE MENSAGENS */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="messageHistory-label">{i18n.t("settings.options.fields.messageHistory.label")}</InputLabel>
            <Select
              labelId="messageHistory-label"
              value={messageHistory}
              onChange={async (e) => {
                handleMessageHistory(e.target.value);
              }}
            >
              <MenuItem value={"contact"}>{i18n.t("settings.options.fields.messageHistory.options.contact")}</MenuItem>
              <MenuItem value={"ticket"}>{i18n.t("settings.options.fields.messageHistory.options.ticket")}</MenuItem>
              <MenuItem value={"whatsapp"}>{i18n.t("settings.options.fields.messageHistory.options.whatsapp")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingMessageHistory ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.messageHistory.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>

		{/* IMPORTAÇÃO DE CLIENTES */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="ticketConnectionScope-label">{i18n.t("settings.options.fields.ticketConnectionScope.label")}</InputLabel>
            <Select
              labelId="ticketConnectionScope-label"
              value={ticketConnectionScope}
              onChange={async (e) => {
                handleTicketConnectionScope(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.ticketConnectionScope.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.ticketConnectionScope.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingTicketConnectionScope ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.ticketConnectionScope.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* FINALIZAR CHAMADO SEM INTERAÇÃO COM O CONTATO */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="ticketCloseWithoutInteraction-label">{i18n.t("settings.options.fields.ticketCloseWithoutInteraction.label")}</InputLabel>
            <Select
              labelId="ticketCloseWithoutInteraction-label"
              value={ticketCloseWithoutInteraction}
              onChange={async (e) => {
                handleTicketCloseWithoutInteraction(e.target.value);
              }}
            >
              <MenuItem value={"allowed"}>{i18n.t("settings.options.fields.ticketCloseWithoutInteraction.options.allowed")}</MenuItem>
              <MenuItem value={"warn"}>{i18n.t("settings.options.fields.ticketCloseWithoutInteraction.options.warn")}</MenuItem>
              <MenuItem value={"blocked"}>{i18n.t("settings.options.fields.ticketCloseWithoutInteraction.options.blocked")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingTicketCloseWithoutInteraction ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.ticketCloseWithoutInteraction.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* PERGUNTAR SE ENVIA A MENSAGEM DE CONCLUSÃO DA CONEXÃO AO FINALIZAR */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="askCompletionMessageOnClose-label">{i18n.t("settings.options.fields.askCompletionMessageOnClose.label")}</InputLabel>
            <Select
              labelId="askCompletionMessageOnClose-label"
              value={askCompletionMessageOnClose}
              onChange={async (e) => {
                handleAskCompletionMessageOnClose(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.askCompletionMessageOnClose.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.askCompletionMessageOnClose.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingAskCompletionMessageOnClose ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.askCompletionMessageOnClose.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="clientImport-label">{i18n.t("settings.options.fields.clientImport.label")}</InputLabel>
            <Select
              labelId="clientImport-label"
              value={clientImport}
              onChange={async (e) => {
                handleClientImport(e.target.value);
              }}
            >
              <MenuItem value={"enabled"}>{i18n.t("settings.options.fields.clientImport.options.enabled")}</MenuItem>
              <MenuItem value={"disabled"}>{i18n.t("settings.options.fields.clientImport.options.disabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingClientImport ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.clientImport.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* TIPO DE CONEXÃO WHATSAPP */}
        {allowQrConnection && (
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="whatsappConnectionType-label">{i18n.t("settings.options.fields.whatsappConnectionType.label")}</InputLabel>
            <Select
              labelId="whatsappConnectionType-label"
              value={whatsappConnectionType}
              onChange={async (e) => {
                handleWhatsappConnectionType(e.target.value);
              }}
            >
              <MenuItem value={"both"}>{i18n.t("settings.options.fields.whatsappConnectionType.options.both")}</MenuItem>
              <MenuItem value={"baileys"}>{i18n.t("settings.options.fields.whatsappConnectionType.options.baileys")}</MenuItem>
              <MenuItem value={"cloudapi"}>{i18n.t("settings.options.fields.whatsappConnectionType.options.cloudapi")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingWhatsappConnectionType ? i18n.t("settings.options.loading") : i18n.t("settings.options.fields.whatsappConnectionType.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>
        )}

        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="attendanceAlarmEnabled-label">
              {i18n.t("settings.options.fields.attendanceAlarmEnabled.label")}
            </InputLabel>
            <Select
              labelId="attendanceAlarmEnabled-label"
              value={attendanceAlarmEnabled}
              onChange={async (e) => {
                handleAttendanceAlarmEnabled(e.target.value);
              }}
            >
              <MenuItem value={"enabled"}>
                {i18n.t("settings.options.fields.attendanceAlarmEnabled.options.enabled")}
              </MenuItem>
              <MenuItem value={"disabled"}>
                {i18n.t("settings.options.fields.attendanceAlarmEnabled.options.disabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingAttendanceAlarmEnabled
                ? i18n.t("settings.options.loading")
                : i18n.t("settings.options.fields.attendanceAlarmEnabled.helper")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {attendanceAlarmEnabled === "enabled" && (
          <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="attendanceAlarmMinutes"
              name="attendanceAlarmMinutes"
              margin="dense"
              label={i18n.t("settings.options.fields.attendanceAlarmMinutes.label")}
              variant="outlined"
              type="number"
              inputProps={{ min: 1, step: 1 }}
              value={attendanceAlarmMinutes}
              onChange={(e) => setAttendanceAlarmMinutes(e.target.value)}
              onBlur={(e) => handleAttendanceAlarmMinutes(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleAttendanceAlarmMinutes(attendanceAlarmMinutes);
                }
              }}
            />
            <FormHelperText>
              {loadingAttendanceAlarmMinutes
                ? i18n.t("settings.options.loading")
                : i18n.t("settings.options.fields.attendanceAlarmMinutes.helper")}
            </FormHelperText>
          </FormControl>
          </Grid>
        )}

        {attendanceAlarmEnabled === "enabled" && (
          <Grid xs={12} sm={6} md={4} item>
            <FormControl className={classes.selectContainer}>
              <InputLabel id="attendanceAlarmResetEnabled-label">
                {i18n.t("settings.options.fields.attendanceAlarmResetEnabled.label")}
              </InputLabel>
              <Select
                labelId="attendanceAlarmResetEnabled-label"
                value={attendanceAlarmResetEnabled}
                onChange={async (e) => {
                  handleAttendanceAlarmResetEnabled(e.target.value);
                }}
              >
                <MenuItem value={"enabled"}>
                  {i18n.t("settings.options.fields.attendanceAlarmResetEnabled.options.enabled")}
                </MenuItem>
                <MenuItem value={"disabled"}>
                  {i18n.t("settings.options.fields.attendanceAlarmResetEnabled.options.disabled")}
                </MenuItem>
              </Select>
              <FormHelperText>
                {loadingAttendanceAlarmResetEnabled
                  ? i18n.t("settings.options.loading")
                  : i18n.t("settings.options.fields.attendanceAlarmResetEnabled.helper")}
              </FormHelperText>
            </FormControl>
          </Grid>
        )}

        {isAdmin && (
          <Grid xs={12} sm={6} md={4} item>
            <FormControl className={classes.selectContainer}>
              <TextField
                id="transcriptionApiKey"
                name="transcriptionApiKey"
                margin="dense"
                label={i18n.t("settings.options.fields.transcriptionApiKey.label")}
                variant="outlined"
                type={showTranscriptionApiKey ? "text" : "password"}
                autoComplete="off"
                value={transcriptionApiKey}
                onChange={(e) => setTranscriptionApiKey(e.target.value)}
                onBlur={(e) => handleTranscriptionApiKey(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleTranscriptionApiKey(transcriptionApiKey);
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label={i18n.t("settings.options.fields.transcriptionApiKey.showHide")}
                        onClick={() => setShowTranscriptionApiKey((prev) => !prev)}
                        onMouseDown={(e) => e.preventDefault()}
                        edge="end"
                        size="small"
                      >
                        {showTranscriptionApiKey ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <FormHelperText>
                {loadingTranscriptionApiKey
                  ? i18n.t("settings.options.loading")
                  : i18n.t("settings.options.fields.transcriptionApiKey.helper")}
              </FormHelperText>
            </FormControl>
          </Grid>
        )}

      </Grid>
      <Grid spacing={3} container>
        <Tabs
          value={0}
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="on"
          variant="scrollable"
          className={classes.tab}
          style={{
            marginBottom: 20,
            marginTop: 20
          }}
        >
          <Tab

            label={i18n.t("settings.options.sections.integrations")} />

        </Tabs>

      </Grid>
      {/*-----------------IXC DESATIVADO 4.6.5-----------------*/}
      {/*<Grid spacing={3} container
        style={{ marginBottom: 10 }}>
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="on"
          variant="scrollable"
          className={classes.tab}
        >
          <Tab

            label="IXC" />

        </Tabs>
        <Grid xs={12} sm={6} md={6} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="ipixc"
              name="ipixc"
              margin="dense"
              label="IP do IXC"
              variant="outlined"
              value={ipixcType}
              onChange={async (e) => {
                handleChangeIPIxc(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingIpIxcType && "Atualizando..."}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={6} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="tokenixc"
              name="tokenixc"
              margin="dense"
              label="Token do IXC"
              variant="outlined"
              value={tokenixcType}
              onChange={async (e) => {
                handleChangeTokenIxc(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingTokenIxcType && "Atualizando..."}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>*/}
      {/*-----------------MK-AUTH DESATIVADO 4.6.5-----------------*/}
      {/*<Grid spacing={3} container
        style={{ marginBottom: 10 }}>
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="on"
          variant="scrollable"
          className={classes.tab}
        >
          <Tab label="MK-AUTH" />

        </Tabs>
        <Grid xs={12} sm={12} md={4} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="ipmkauth"
              name="ipmkauth"
              margin="dense"
              label="Ip Mk-Auth"
              variant="outlined"
              value={ipmkauthType}
              onChange={async (e) => {
                handleChangeIpMkauth(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingIpMkauthType && "Atualizando..."}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={12} md={4} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="clientidmkauth"
              name="clientidmkauth"
              margin="dense"
              label="Client Id"
              variant="outlined"
              value={clientidmkauthType}
              onChange={async (e) => {
                handleChangeClientIdMkauth(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingClientIdMkauthType && "Atualizando..."}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={12} md={4} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="clientsecretmkauth"
              name="clientsecretmkauth"
              margin="dense"
              label="Client Secret"
              variant="outlined"
              value={clientsecretmkauthType}
              onChange={async (e) => {
                handleChangeClientSecrectMkauth(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingClientSecrectMkauthType && "Atualizando..."}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>*/}
      {/*-----------------ASAAS-----------------*/}
      <Grid spacing={3} container
        style={{ marginBottom: 10 }}>
        <Tabs
          value={0}
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="on"
          variant="scrollable"
          className={classes.tab}
        >
          <Tab label={i18n.t("settings.options.sections.asaas")} />

        </Tabs>
        <Grid xs={12} sm={12} md={12} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="asaas"
              name="asaas"
              margin="dense"
              label={i18n.t("settings.options.fields.asaasToken.label")}
              variant="outlined"
              value={asaasType}
              onChange={async (e) => {
                handleChangeAsaas(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingAsaasType && i18n.t("settings.options.loading")}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      {/*-----------------AVISO DE TRANSFERÊNCIA DA IA-----------------*/}
      {isAdmin && (
        <Grid spacing={3} container
          style={{ marginBottom: 10 }}>
          <Tabs
            value={0}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="on"
            variant="scrollable"
            className={classes.tab}
          >
            <Tab label={i18n.t("settings.options.sections.aiTransferNotify")} />
          </Tabs>
          <Grid xs={12} sm={6} md={4} item>
            <FormControl className={classes.selectContainer}>
              <InputLabel id="aiTransferNotifyEnabled-label">
                {i18n.t("settings.options.fields.aiTransferNotifyEnabled.label")}
              </InputLabel>
              <Select
                labelId="aiTransferNotifyEnabled-label"
                value={aiTransferNotifyEnabled}
                onChange={(e) => handleAiTransferNotifyEnabled(e.target.value)}
              >
                <MenuItem value={"disabled"}>
                  {i18n.t("settings.options.fields.aiTransferNotifyEnabled.options.disabled")}
                </MenuItem>
                <MenuItem value={"enabled"}>
                  {i18n.t("settings.options.fields.aiTransferNotifyEnabled.options.enabled")}
                </MenuItem>
              </Select>
              <FormHelperText>
                {loadingAiTransferNotifyEnabled
                  ? i18n.t("settings.options.loading")
                  : i18n.t("settings.options.fields.aiTransferNotifyEnabled.helper")}
              </FormHelperText>
            </FormControl>
          </Grid>

          {aiTransferNotifyEnabled === "enabled" && (
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.selectContainer}>
                <InputLabel id="aiTransferNotifyConnectionId-label">
                  {i18n.t("settings.options.fields.aiTransferNotifyConnectionId.label")}
                </InputLabel>
                <Select
                  labelId="aiTransferNotifyConnectionId-label"
                  value={aiTransferNotifyConnectionValue}
                  onChange={(e) => handleAiTransferNotifyConnectionId(e.target.value)}
                >
                  <MenuItem value="">
                    <em>{i18n.t("settings.options.fields.aiTransferNotifyConnectionId.none")}</em>
                  </MenuItem>
                  {aiTransferNotifyConnections.map((w) => (
                    <MenuItem key={w.id} value={String(w.id)}>
                      {w.status === "CONNECTED" ? w.name : `${w.name} (${w.status})`}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {loadingAiTransferNotifyConnectionId
                    ? i18n.t("settings.options.loading")
                    : i18n.t("settings.options.fields.aiTransferNotifyConnectionId.helper")}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}

          {aiTransferNotifyEnabled === "enabled" && (
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.selectContainer}>
                <TextField
                  id="aiTransferNotifyNumbers"
                  name="aiTransferNotifyNumbers"
                  margin="dense"
                  label={i18n.t("settings.options.fields.aiTransferNotifyNumbers.label")}
                  variant="outlined"
                  placeholder="5542999999999"
                  autoComplete="off"
                  value={aiTransferNotifyNumbers}
                  onChange={(e) => setAiTransferNotifyNumbers(e.target.value)}
                  onBlur={(e) => handleAiTransferNotifyNumbers(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleAiTransferNotifyNumbers(aiTransferNotifyNumbers);
                    }
                  }}
                />
                <FormHelperText>
                  {loadingAiTransferNotifyNumbers
                    ? i18n.t("settings.options.loading")
                    : i18n.t("settings.options.fields.aiTransferNotifyNumbers.helper")}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}
        </Grid>
      )}
    </>
  );
}
